import { createAPIRequest, createAPIResponse, ListResponse } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';
import useSWR from 'swr';

export type NormalTimeDTO = {
    id: number;
    hoursPerDay: number;
};

export function useLatestNormalTime() {
    const { data, error, isLoading } = useSWR<ListResponse<NormalTimeDTO>>(getSalaryNormalTimeURL(), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return { data: data?.values[data.values.length - 1], error, isLoading };
}

function getSalaryNormalTimeURL({ id }: { id?: number } = {}) {
    const defaultFields = ['id', 'hoursPerDay'];
    const params = new URLSearchParams();
    params.set('fields', [...defaultFields].sort().join(','));

    return `${APIUrls.SALARY_SETTINGS_NORMAL_TIME}/${id ?? ''}?${params.toString()}`;
}

export async function updateNormalTime(id: number, dto: Partial<NormalTimeDTO>) {
    const request = createAPIRequest(getSalaryNormalTimeURL({ id }), {
        method: 'PUT',
        body: JSON.stringify(dto),
        headers: {
            'content-type': 'application/json; charset=utf-8',
        },
    });
    const response = await window.fetch(request);
    return await createAPIResponse(request, response);
}
